import React from 'react';
import { useAuth } from '../contexts/AuthContext';
import './Header.css';

function Header({ title }) {
  const { logout } = useAuth();

  const handleLogout = async () => {
    try {
      await logout();
    } catch (error) {
    }
  };

  return (
    <header className="header">
      <div className="header-content">
        <h1 className="header-title">{title}</h1>
        <button onClick={handleLogout} className="logout-btn" title="Logout">
          Logout
        </button>
      </div>
    </header>
  );
}

export default Header;

